<template>
  <v-app>
    <appbar-view></appbar-view>

    <v-main class="main-content">
      <v-container>
        <!-- Campo de búsqueda -->
        <v-row>
          <v-col cols="12">
            <!-- Banner -->

            <div class="bg-cover bg-center py-2">
              <div class="bg-cover bg-center py-8">
                <div class="flex items-center justify-center">
                  <img
                    src="https://seeklogo.com/images/A/alen-logo-82461FA1E0-seeklogo.com.png"
                    alt="Banner"
                    class="w-32 md:w-48 lg:w-64 h-auto mb-4"
                  />
                </div>
              </div>
            </div>

            <div class="mb-3">
              <div class="relative w-full max-w-md mx-auto">
                <input
                  v-model="searchQuery"
                  type="text"
                  placeholder="Buscar productos"
                  class="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-400"
                />
                <span class="absolute left-3 top-2.5 text-gray-400">
                  <i class="mdi mdi-magnify"></i>
                </span>
              </div>
            </div>
          </v-col>
          <!-- Botón de filtros -->
          <!-- Boton de filtros -->
          <v-row justify="start">
            <v-col cols="auto">
              <v-tooltip text="Filtrar y ordenar">
                <template v-slot:activator="{ props }">
                  <v-btn
                    v-bind="props"
                    variant="elevated"
                    color="#fb8c00"
                    class="rounded-lg px-4 py-2 text-indigo-darken-4 d-flex align-center"
                    @click="dialogFiltro = true"
                  >
                    <v-icon class="mr-2">mdi-filter-variant</v-icon>
                    <span class="font-weight-medium text-caption text-uppercase"
                      >Filtrar</span
                    >
                  </v-btn>
                </template>
              </v-tooltip>
            </v-col>
          </v-row>

          <!-- Filtro de precios menor que y mayor que -->
          <v-dialog v-model="dialogFiltro" max-width="420">
            <v-card class="rounded-lg" color="orange-lighten-1 text-white">
              <v-card-title class="bg-blue-darken-4 text-white">
                <v-icon class="mr-2">mdi-filter-cog</v-icon> Filtrar y ordenar
              </v-card-title>

              <v-card-text class="py-4">
                <v-switch
                  v-model="sortByPrice"
                  color="blue-darken-4"
                  label="Ordenar por precio"
                >
                  <template v-slot:label>
                    <v-icon small class="mr-1"></v-icon>
                    <div class="text-blue-darken-4">
                      <strong> De menor a mayor</strong>
                    </div>
                  </template>
                </v-switch>

                <v-select
                  v-model="selectedBrand"
                  :items="brands"
                  label="Filtrar por Marca"
                  clearable
                  color="blue-darken-4"
                  outlined
                  dense
                  item-color="white"
                  :list-props="{ bgColor: 'blue-darken-4' }"
                >
                  <template v-slot:prepend-item>
                    <v-icon left>mdi-filter</v-icon>
                  </template>
                </v-select>
                <v-btn
                  color="#223b78"
                  variant="flat"
                  class="rounded-lg px-4 text-white"
                  @click="applyFilters"
                >
                  <v-icon class="mr-1">mdi-check</v-icon>
                  Aplicar
                </v-btn>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-row>

        <!-- Botón del carrito flotante -->
        <v-btn
          v-bind="props"
          @click="openCart"
          color="blue-darken-4"
          class="fixed-cart-btn text-white"
          elevation="4"
        >
          <v-icon left>mdi-cart-outline</v-icon>
          Ver Canasta ({{ totalCajas }})
        </v-btn>

        <!-- Productos -->
        <v-row dense>
          <v-col
            v-for="product in filteredProducts"
            :key="product.id"
            cols="6"
            sm="6"
            md="4"
            lg="3"
            class="d-flex justify-center"
          >
            <v-card class="pa-4" variant="transparent" style="width: 240px">
              <v-row>
                <div class="d-flex align-center" style="position: relative">
                  <!-- Bloque de botones (+ / -) -->
                  <div
                    v-if="getProductQuantity(product) > 0"
                    class="d-flex align-center mt-2"
                  >
                    <!-- Botón para disminuir la cantidad -->
                    <v-btn
                      icon
                      @click="decreaseQuantity(product)"
                      variant="transparent"
                      density="compact"
                      color="orange-darken-1"
                    >
                      <v-icon>mdi-minus-circle</v-icon>
                    </v-btn>

                    <!-- Cantidad actual -->
                    <span
                      class="px-2 text-caption font-weight-bold"
                      style="font-size: 1.2em"
                    >
                      {{ getProductQuantity(product) }}
                    </span>

                    <!-- Botón para aumentar -->
                    <v-btn
                      icon
                      size="42"
                      @click="increaseQuantity(product)"
                      density="compact"
                      variant="transparent"
                      color="blue-darken-4"
                      :disabled="
                        product.id_promocion
                          ? getProductQuantity(product) >= 1 // 🔒 Si tiene promo, máximo 1
                          : getProductQuantity(product) >= product.yfr_disponible
                      "
                    >
                      <v-icon>mdi-plus-circle</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-row>

              <v-row class="d-flex justify-center" style="position: relative">
                <v-col cols="9" style="position: relative">
                  <!-- Imagen -->
                  <v-img
                    lazyloading
                    :src="product.foto || 'default-image-url'"
                    height="100px"
                    class="rounded"
                    size="40"
                  />

                  <!-- Icono de agregar -->
                  <v-icon
                    color="blue-darken-4"
                    size="42"
                    v-ripple
                    class="add-icon"
                    style="
                      position: absolute;
                      top: 5px;
                      right: 5px;
                      background: white;
                      border-radius: 50%;
                      padding: 2px;
                      cursor: pointer;
                    "
                    :disabled="
                      product.id_promocion
                        ? getProductQuantity(product) >= 1 // 🔒 Si tiene promo, solo 1
                        : getProductQuantity(product) >= product.yfr_disponible
                    "
                    @click="
                      ((product.id_promocion && getProductQuantity(product) < 1) ||
                        (!product.id_promocion &&
                          getProductQuantity(product) < product.yfr_disponible)) &&
                        addToCart(product)
                    "
                    :class="{
                      'v-icon--disabled': product.id_promocion
                        ? getProductQuantity(product) >= 1
                        : getProductQuantity(product) >= product.yfr_disponible,
                    }"
                    :style="
                      getProductQuantity(product) > 0
                        ? 'pointer-events: none; opacity: 0;'
                        : ''
                    "
                  >
                    mdi-plus-circle
                  </v-icon>
                </v-col>
              </v-row>

              <!-- Precio / Promo -->
              <div
                class="w-full text-center mt-4 p-3 transition-shadow duration-300 space-y-1"
              >
                <template v-if="product.id_promocion && product.promo_price">
                  <div class="text-gray-500 line-through font-semibold">
                    ${{ product.price }}
                  </div>
                  <div class="text-base sm:text-lg md:text-xl font-semibold text-red">
                    ${{
                      (
                        product.price -
                        (product.price * product.promo_price) / 100
                      ).toFixed(2)
                    }}
                  </div>
                </template>
                <template v-else>
                  <div
                    class="text-base sm:text-lg md:text-xl font-semibold text-blue-700"
                  >
                    ${{ product.price }}
                  </div>
                </template>

                <!-- Nombre -->
                <div class="text-xs sm:text-sm md:text-base font-medium text-gray-700">
                  {{ product.nombre }}
                </div>

                <!-- SKU -->
                <div class="text-xs sm:text-sm font-medium text-gray-400">
                  SKU: {{ product.sku }}
                </div>

                <!-- Distintivo de promoción -->
                <div
                  v-if="product.id_promocion && product.promo_price"
                  class="mt-1 inline-block px-2 py-1 bg-green-500 text-white text-xs font-bold rounded-full"
                >
                  Descuento {{ product.promo_price }}%
                </div>

                <!-- Agotado -->
                <div
                  v-if="product.yfr_disponible <= 0"
                  class="text-sm sm:text-base font-semibold text-red-500"
                >
                  Agotado
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Diálogo del carrito -->
        <CartDialog v-model="cartDialog" />
      </v-container>
    </v-main>
  </v-app>
  <bottom-navigation class="fixed-bottom-nav"></bottom-navigation>
</template>

<script>
import axios from "axios";
import AppbarView from "../appbar/appbarView.vue";
import BottomNavigation from "../submenu/BottomNavigation.vue";
import CartDialog from "../Administrador/CarritoViewStore.vue"; // Asegúrate de que la ruta sea correcta
import { inject, computed } from "vue";

export default {
  name: "AllenView",
  components: { BottomNavigation, AppbarView, CartDialog },
  setup() {
    // Inyectar el store del carrito
    const cartStore = inject("cartStore"); // Asegúrate de que 'cartStore' esté proporcionado globalmente

    // Usar los métodos del store global
    const addToCart = cartStore.addToCart;
    const increaseQuantity = cartStore.increaseQuantity;
    const decreaseQuantity = cartStore.decreaseQuantity;
    const getProductQuantity = cartStore.getProductQuantity;
    const totalCajas = computed(() => {
      return cartStore.state.cart.reduce((total, item) => total + item.quantity, 0);
    });

    return {
      addToCart, // Usar el método global para agregar al carrito
      increaseQuantity, // Usar el método global para aumentar la cantidad
      decreaseQuantity, // Usar el método global para disminuir la cantidad
      getProductQuantity,
      totalCajas,
    };
  },
  data() {
    return {
      searchQuery: "",
      products: [],
      cart: [],
      cartDialog: false,
      suggestedItems: [],
      sortByPrice: false,
      dialogFiltro: false,
      selectedBrands: [], // Para múltiples valores
      selectedBrand: null,
      currentPage: 1,
      hasMoreProducts: true,
      brands: [], // Aseguramos que las marcas estén vacías al inicio
    };
  },
  computed: {
    filteredProducts() {
      let products = this.products.filter((product) => {
        const matchesSearch = product.nombre
          .toLowerCase()
          .includes(this.searchQuery.toLowerCase());
        const matchesBrand = this.selectedBrand
          ? product.sublinea === this.selectedBrand
          : this.selectedBrands.length > 0
          ? this.selectedBrands.includes(product.sublinea)
          : true;

        return matchesSearch && matchesBrand;
      });
      if (this.sortByPrice) {
        products = products.sort((a, b) => a.price - b.price);
      }

      return products;
    },
  },
  methods: {
    clearCart() {
      this.cart = []; // Vaciar el carrito
      localStorage.removeItem("cart"); // Limpiar el almacenamiento local
    },

    openCart() {
      this.cartDialog = true;
      this.suggestedProducts();
    },

    applyFilters() {
      this.dialogFiltro = false;
    },
    async fetchProducts(page = 1) {
      try {
        const token = localStorage.getItem("token");

        if (!token) {
          console.error("No token found, please login again");
          return;
        }

        const limit = 20; // Número de productos por página
        const offset = (page - 1) * limit; // Calcular el desplazamiento

        // --- CACHE LOGIC ---
        const cacheKey = `products_allen_${page}`;
        const cacheTimeKey = `products_allen_${page}_time`;
        const now = Date.now();
        const cacheDuration = 0 * 60 * 1000; // 10 minutos

        const cachedData = localStorage.getItem(cacheKey);
        const cachedTime = localStorage.getItem(cacheTimeKey);

        if (cachedData && cachedTime && now - cachedTime < cacheDuration) {
          const parsed = JSON.parse(cachedData);

          this.products = [
            ...this.products,
            ...parsed.products.map((product) => ({
              ...product,
              price: product.price || 0,
            })),
          ];

          this.hasMoreProducts = parsed.hasMore;
          this.brands = [...new Set(this.products.map((product) => product.sublinea))];
          return;
        }

        // --- FETCH FROM API ---
        const response = await axios.get(
          "https:///110-alen",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            params: {
              limit,
              offset,
            },
          }
        );

        const fetchedProducts = response.data.map((product) => ({
          ...product,
          price: product.price || 0,
        }));

        this.products = [...this.products, ...fetchedProducts];

        this.hasMoreProducts = fetchedProducts.length >= limit;

        this.brands = [...new Set(this.products.map((product) => product.sublinea))];

        // --- SAVE TO CACHE ---
        localStorage.setItem(
          cacheKey,
          JSON.stringify({
            products: fetchedProducts,
            hasMore: this.hasMoreProducts,
          })
        );
        localStorage.setItem(cacheTimeKey, now);
      } catch (error) {
        console.error("Error fetching products:", error.message);
      }
    },

    loadMoreProducts() {
      if (this.hasMoreProducts) {
        this.currentPage++;
        this.fetchProducts(this.currentPage);
      }
    },
    suggestedProducts() {
      axios
        .get("https:///suggested-products")
        .then((res) => {
          if (Array.isArray(res.data) && res.data.length > 0) {
            this.suggestedItems = res.data;
          } else {
            console.error("No se encontraron productos sugeridos.");
          }
        })
        .catch((err) => {
          console.error("Error fetching suggested products:", err);
        });
    },

    handleScroll() {
      const scrollPosition = window.innerHeight + window.scrollY; // Posición actual del scroll
      const bottomPosition = document.documentElement.offsetHeight; // Altura total del documento

      // Si el usuario está cerca del final de la página, cargar más productos
      if (scrollPosition >= bottomPosition - 100 && this.hasMoreProducts) {
        this.loadMoreProducts();
      }
    },
  },
  mounted() {
    const token = localStorage.getItem("token");
    if (!token) {
      window.location.replace("/"); // Redirige y borra el historial
    }

    this.fetchProducts(); // Cargar la primera página de productos al montar el componente

    const saveCart = localStorage.getItem("cart");
    if (saveCart) {
      this.cart = JSON.parse(saveCart);
    }

    // Agregar el evento de scroll
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    // Cambiado de beforeDestroy a beforeUnmount
    // Eliminar el evento de scroll al destruir el componente
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped>
.main-content {
  padding-bottom: 80px;
  background-image: "https:///images/naranja%20azul.png";
}

.fixed-bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}

.cart-item {
  padding: 10px 0;
}

.v-dialog .v-card {
  background-color: #ffffff;
}

.v-row {
  margin-bottom: 10px;
}
</style>

<style scoped>
.cart-table {
  width: 100%;
  border-collapse: collapse;
}

.cart-table th,
.cart-table td {
  border: 1px solid #ddd;
  padding: 8px;
}

.cart-table th {
  background-color: #f5f5f5;
  text-align: left;
}

.actions-column {
  width: 150px;
  /* Ajusta el tamaño de la columna de acciones */
  text-align: center;
}

.fixed-cart-btn {
  position: fixed;
  bottom: 70px;
  /* Distancia desde el fondo, ajusta este valor para subir más o bajar el botón */
  left: 50%;
  transform: translateX(-50%);
  /* Centra el botón horizontalmente */
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  border-radius: 50px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  font-size: 16px;
}

.v-dialog__content {
  z-index: 9999;
  /* Asegura que el diálogo esté por encima del carrito */
}

.fixed-bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  padding: 10px;
}

.main-content {
  padding-bottom: 80px;
  /* Asegura que el contenido no quede tapado por el pie de página */
}

v-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #f5f5f5;
  padding: 10px 0;
  text-align: center;
}
</style>
